import { render, staticRenderFns } from "./VuebaseLayout.vue?vue&type=template&id=6e31132f"
import script from "./VuebaseLayout.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayout.vue?vue&type=style&index=0&id=6e31132f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./VuebaseLayout.vue?vue&type=custom&index=0&blockType=styl"
if (typeof block0 === 'function') block0(component)

export default component.exports